import {Component, OnInit} from '@angular/core';
import {Invoice} from '../../../dto/invoice';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Location} from '@angular/common';
import {InvoicesService} from '../../services/invoices.service';
import {toDateTimeString} from '../../../providers/app-date-adapter';
import {FileHelper} from '../../../helpers/file-helper';

import {RoleService} from '../../../services/role.service';
import {ObjectComment} from '../../../dto/object-comment';
import {ObjectCommentsService} from '../../services/object-comment.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Payment} from '../../../dto/payment';
import {PrevNextModel} from '../../../models/prev-next-model';
import {getTableFilters} from '../../../helpers/storage-helper';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {EmailSendStatus} from '../../../dto/order-status';
import {Customer} from "../../../dto/customer";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {ToastService} from "angular-toastify";
import {ContentRowField} from "../../../shared/content-row/content-row.component";
import {
  AddressConfirmDialogComponent
} from "../../../shared/confirm-dialog/address-confirm-dialog/address-confirm-dialog.component";
import {AddressUpdateModel} from "../../../models/address-update-model";
import {CustomerChangeAddressStatusModel} from "../../../models/customer-change-address-status-model";
import {ChooseDateDialogComponent} from "../../../shared/choose-date-dialog/choose-date-dialog.component";


@Component({
  selector: 'app-invoice-view',
  templateUrl: './invoice-view.component.html',
  styleUrls: ['./invoice-view.component.css']
})
export class InvoiceViewComponent implements OnInit {

  types: {[key: string]: string} = {
    INVOICE: 'Invoice',
    VOUCHER: 'Voucher',
    SOFORT: 'Sofort',
    CASH: 'Cash on delivery',
    CREDIT_CARD: 'Credit Card'
  };

  invoice: Invoice|null;
  comments: ObjectComment[];
  commentsTarget = 3;


  previewFileOpen = false;
  isLoadingPreview = false;
  previewType = 0;
  previewUrlSafe: SafeResourceUrl;
  previewFilename: string|null;
  previewErrorMsg: string|null;

  fields = [
    // { header: "Code", cell: (row: Invoice) => `${row.code}` },


    { header: 'Type', cell: (row: Invoice) => `${row.invoiceTypeName}` },
    { header: 'Email Delivery', cell: (row: Invoice) => `${row.email}`

    , icon: (row: Invoice) => {
  if ( row.emailSendStatus == EmailSendStatus.Undeliverable ) {
  return 'front_hand';
}
if ( row.emailSendStatus == EmailSendStatus.Deliverable) {
  return 'mark_email_read';
}
return 'email';
}, iconColor: (row: Invoice) => {

  if ( row.emailSendStatus == EmailSendStatus.Undeliverable && row.emailRejectedCount >= 3) {
    return '#ff0000';
  }
  if ( row.emailSendStatus == EmailSendStatus.Undeliverable) {
    return '#ff9900';
  }

  if ( row.emailSendStatus == EmailSendStatus.Deliverable) {
    return '#008400';
  }

  return false;
}



    },

    { header: 'Card', link: (row: Invoice) => '../../cards/' + (row.cardId || ''), cell: (row: Invoice) => {
      if ( row.card ) {
        return row.card.token;
      }
      } },

    //{ header: 'Annual Fee', cell: (row: Invoice) => `${row.annualFeeAtCreation.formatMoneyEuro()}` },
    { header: 'VAT Rate', cell: (row: Invoice) => `${row.vatRateAtCreation}` },
    { header: 'Paid / Bill', cell: (row: Invoice) => `${row.paidAmount.formatMoneyEuro()} / ${row.billAmount.formatMoneyEuro()}` },
    { header: 'Creation', cell: (row: Invoice) => `${toDateTimeString(row.creationDate)}` },
    { header: 'Marked as paid', cell: (row: Invoice) => `${toDateTimeString(row.markedAsPaidDate)}` },

    { header: 'Dunning stop', hidden: row => row.dunningStopDate == null, cellColor: row => new Date(row.dunningStopDate) >= new Date() ? 'black': 'grey', cell: (row: Invoice) => row.dunningStopDate ? `🟣 ${toDateTimeString(row.dunningStopDate)}` : '' },

    { header: 'Debt collection', cell: (row: Invoice) => {

        if ( row.isDebtCollectionEnabled && row.debtorDistributionId == null && row.paidAmount < row.billAmount)
          return '🔵 Yes, if not paid';
        if ( row.isDebtCollectionEnabled && row.debtorDistributionId == null && row.paidAmount == row.billAmount)
          return '🟢 No - paid';
        if ( row.debtorDistributionId != null)
          return '🟠 In collection';

        return `${row.isDebtCollectionEnabled ? "🔵 Enabled" : "⚪️ Disabled"}`;
      }


    },

    { header: 'Orders count', cell: (row: Invoice) => `${row.voucherOrderId != null ? 1 : row.ordersCount}` },
    { header: 'Product', cell: (row: Invoice) => {
      if( row.productName == null ) {
return '-';
} else {
return row.productName;
}
      }
    },
    // { header: "Company", cell: (row: Invoice) => `${row.productCompanyName}` },
    { header: 'Outstanding', cell: (row: Invoice) => `${row.outstandingAmount.formatMoneyEuro()}`, cellColor: row => {
        if ( row.outstandingAmount == 0 )
          return 'forestgreen';
        if ( row.outstandingAmount > 0 && row.debtorDistributionId != null && row.paidAmount / .7 >= row.billAmount)
          return 'blue';

        if ( row.debtorDistributionId != null)
          return 'red';

        return 'darkorange';

      }

    },
    { header: 'Voucher code', cell: (row: Invoice) => {
        if (row.ordersCount === 1 && row.firstOrder.voucherCode ) {
return row.firstOrder.voucherCode;
}
        return '-';
      }
    },
    { header: 'Partner price', cell: (row: Invoice) => `${row.partnerPrice.formatMoneyEuro()}` },
    // { header: "Total", cell: (row: Invoice) => `${row.partnerPrice + row.annualFeeAtCreation}` },
    { header: 'Invoice issuer', cell: (row: Invoice) => {
        if( row.invoicingCompany == null ) {
return '-';
} else {
return row.invoicingCompany;
}
      }
    },
    //{ header: "IBAN/BIC", cell: (row: Invoice) => `${row.iban} / ${row.bic}` },
    {
      header: 'Payment', cell: (row: Invoice) => {

        let ret = 'unknown';

        if (row.paymentType) {
if (this.types[row.paymentType]) {
ret = this.types[row.paymentType];
}
}

        return ret;
      }
    } as ContentRowField<Invoice>,

  ] as ContentRowField<Invoice>[];

  prevNext: PrevNextModel;


  paymentForm: FormGroup;
  payments: Payment[];
  isLoadingPayments = false;
  invoiceId = null;
  payment: Payment;
  isLoading = false;




  constructor(
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private invoicesService: InvoicesService,
    private snackBar: MatSnackBar,
    private roleService: RoleService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private objectCommentsService: ObjectCommentsService,
    private sanitizer: DomSanitizer,
    private _toastService: ToastService,
    )
  {

  }

  ngOnInit() {

    this.route.params.subscribe((params: Params) => {

      this.invoice = null;
      this.payments = null;
      this.comments = null;

      const id = parseInt(this.route.snapshot.paramMap.get('id'));
      this.invoiceId = id;

      this.clearData();
      this.getPrevNext(this.invoiceId);

      this.loadInvoice(id);
      this.loadPayments(id);
      this.initPaymentForm();

      this.loadComments(id);

      this.getDebtorServiceErrorLogs(id);

    });


  }

  restoreInvoice() {

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Restore invoice',
        text: 'Are you sure?'
      },
      minWidth: 350,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'ok') {
        this.invoicesService.restore(this.invoice).subscribe(res => {
          location.reload();
        });
      }
    });


  }

  currentUserIsManager() {
    return this.roleService.hasRoles('manager');
  }

  tempNextId = null;
  deleteInvoice(){

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Delete invoice',
        text: 'Are you sure want to delete this invoice?'
      },
      minWidth: 350,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'ok') {

        const filters = this.getInvoicesTableFilters();
        this.tempNextId = null;
        this.invoicesService.getNext(filters, this.invoiceId).subscribe(result => {
          this.tempNextId = result;



          this.invoicesService.delete(this.invoiceId).subscribe(result => {
                if (this.prevNext != null && this.prevNext.next) {
                  this.router.navigate(['..', this.tempNextId], {relativeTo: this.route});
                } else {
                  this.router.navigate(['/invoices']);
                }
              },
              error => {

              });
        });
      }
    });

  }

  public debtorlogs = null;

  getDebtorServiceErrorLogs(invoiceId: number){

    if( this.currentUserIsAdmin() || this.currentUserIsCompliance() ){
      this.invoicesService.getDebtorServiceErrorLogs(invoiceId).subscribe(result => {
        this.debtorlogs = result;
      });
    }
  }

  deleteEnabled() {

    if( this.currentUserIsManager() ) // &&  this.table.filters.someAdditionalData != null && this.table.filters.someAdditionalData == "annual_fee"
      {
return true;
}

    return this.roleService.hasRoles('admin');
  }

  getInvoicesTableFilters() {
    const a = getTableFilters('invoiceTable');
    return a;
  }

  getPrevNext(id: number) {
    const filters = this.getInvoicesTableFilters();
    console.log(filters);
    this.invoicesService.getPrevNext(filters, id).subscribe(result => {
      this.prevNext = result;
    });
  }

  gotoPrevInvoice(){
    this.previewFileOpen = false;
    const filters = this.getInvoicesTableFilters();
    this.invoicesService.getPrev(filters, this.invoiceId).subscribe(result => {
      this.router.navigate(['..', result], { relativeTo: this.route });
    });

  }

  gotoNextInvoice(){
    this.previewFileOpen = false;
    const filters = this.getInvoicesTableFilters();
    this.invoicesService.getNext(filters, this.invoiceId).subscribe(result => {
      this.router.navigate(['..', result], { relativeTo: this.route });
    });
  }




  clearData() {
    this.prevNext = null;
  }

  loadComments(id){
    this.objectCommentsService.getForObject(id, this.commentsTarget).subscribe(data => {
      this.comments = data;
    });
  }

  loadInvoice(id){
    this.invoicesService.get(id).subscribe(data => {
      this.invoice = data;
    });
  }

  resetSentAttemts(){

    if( !this.currentUserIsAdmin() ) {
return;
}

    if( this.invoice == null ) {
return;
}

    if( this.invoice != null && this.invoice.debtorDistributionId != null ) {
return;
}

    this.invoicesService.resetSentAttempts(this.invoiceId).subscribe(result => {
      if( result != null ) {
this.invoice.sentAttempts = result;
}

    });
  }

  returnBack() {
    this.router.navigate(['/invoices']);
    // this.location.back();
  }

  currentUserIsAdmin() {
 return this.roleService.hasRoles('admin');
}

  currentUserIsCompliance() {
 return this.roleService.hasRoles('compliance');
}

  currentUserIsPartner() {
    return this.roleService.hasRoles('partner');
  }

  currentUserIsAgent() {
    return this.roleService.hasRoles('agent');
  }

  edit() {
    this.router.navigate(['edit'], { relativeTo: this.route });
  }

  downloadAttachment() {
    this.invoicesService.getAttachment(parseInt(this.route.snapshot.paramMap.get('id'))).subscribe(
      result => {


        FileHelper.saveFile(result);
      },
      err =>
        this.snackBar.open(err.error.message || err.message || err.error || err, null, {
          duration: 5000,
          panelClass: ['app-mat-snack-bar']
        })
    );
  }


  loadPayments(id){
    this.isLoadingPayments = true;
    this.invoicesService.getPayments(id).subscribe(result => {
      this.payments = result;
      this.isLoadingPayments = false;
    });
  }

  initPaymentForm() {
    this.payment = new Payment();
    this.payment.date = null;
    this.payment.amount = null;
    this.payment.invoiceId = this.invoiceId;
    this.paymentForm = this.formBuilder.group(this.payment);
  }

  isPaymentSaving = false;
  onPaymentSubmit() {

    this.isPaymentSaving = true;
    this.invoicesService.addPayment(this.paymentForm.value)
        .subscribe(result => {
          this.loadInvoice(this.invoiceId);
          this.loadPayments(this.invoiceId);
          this.initPaymentForm();
          this.isPaymentSaving = false;
          this.loadComments(this.invoiceId);
        });

  }

  deletePayment(paymentId: number){
    this.isLoadingPayments = true;
    this.invoicesService.deletePayment(paymentId)
        .subscribe(result => {
          this.loadInvoice(this.invoiceId);
          this.loadPayments(this.invoiceId);
          this.initPaymentForm();
          this.isLoadingPayments = false;
        });
  }

  editEnabled() {
    return this.roleService.hasRoles('admin');
  }


  previewInvoiceFile(invoiceId: number) {
    this.previewFileOpen = true;
    this.isLoadingPreview = true;
    this.invoicesService.getInvoiceFileInline( invoiceId ).subscribe(
      result => {

        const disposition = result.headers.get('Content-Disposition');
        const contentType = result.headers.get('Content-Type');
        const filename = disposition.split(';')[1].trim().split('=')[1];

        const blob = new Blob([result.body], { type: contentType });
        // FileSaver.saveAs(blob , filename);
        const fileURL = URL.createObjectURL(blob);


        this.previewUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);

        if ( contentType.indexOf('image') >= 0) {
          this.previewType = 2;
        } else {
          this.previewType = 1;
        }
        this.previewErrorMsg = null;
        this.previewFilename = filename;
        this.isLoadingPreview = false;

        // FileHelper.saveFile( result );
      },
      err => {
        this.previewFilename = null;
        this.previewType = 0;
        this.previewErrorMsg = 'Error occured during downloading the file.';
        this.isLoadingPreview = false;
        this._toastService.error( err.error.message || err.message || err.error || err);
      }

    );
  }

  resendInvoice(invoiceId: number) {
    this.invoicesService.resendInvoice(invoiceId).subscribe(_ => {
      this._toastService.success("Invoice has been resent")
    }, err => {
      this._toastService.error( err.error.message || err.message || err.error || err);
    });
  }

  closePreview() {
    this.previewFileOpen = false;
  }

  createInvoicePdf() {
    this.isLoading = true;
    this.invoicesService.generatePdf(this.invoice.id)
      .subscribe(result => {
        this.invoice.pdfId = result.id;
        this.isLoading = false;
        this.previewInvoiceFile(this.invoice.id);
      }, err => {
        this._toastService.error( err.error.message || err.message || err.error || err);
        this.isLoading = false;
      });
  }

  setDunningStopDate(newDunningStopDate: Date) {
    this.isLoading = true;
    this.invoicesService.setDunningStopDate(this.invoice.id, newDunningStopDate)
      .subscribe(result => {
        this.invoice = result;
        this.isLoading = false;
        this.loadComments(this.invoiceId)
        this._toastService.success("Dunning stop date set to " + newDunningStopDate.toDateString());
      }, err => {
        this._toastService.error( err.error.message || err.message || err.error || err);
        this.isLoading = false;
      });
  }

  chooseDunningStopDate() {

    const minDate = new Date();
    minDate.setDate(minDate.getDate() + 1); // Tomorrow

    const maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 1); // One month after specific date


    this.dialog.open(ChooseDateDialogComponent, {
      data: {
        title: 'Please select a date',
        confirm: 'Ok',
        cancel: 'Cancel',
        minDate: minDate,
        maxDate: maxDate,
      },
    }).afterClosed()
      .subscribe(result => {
        if (result) {
          this.setDunningStopDate(result);

        } else {
          console.log('Dialog closed without selection.');
        }
      });


  }
}
